import React, { Fragment, useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button,Select,MenuItem } from '@mui/material/';
import InputLabel from '@mui/material/InputLabel';



import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Autorize from '../../components/ui/autorize';
import { getUserRule} from '../../utils/userRule';
import { useParams } from 'react-router';

import RepportBySector from '../../components/reports/list_secteur';


//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Reports() {

    const [errorAxios, setErrorAxios] = useState("false");
    const [autorize, setAutorize] = useState(false);
    //const autorize = false;
    const [dateDebut, setDateDebut] = useState("");
    const { myear } = useParams();
    const { myreport } = useParams();

    const [dateDebutTmp, setDateDebutTmp] = useState("");
    const [reportname, setreportname] = useState("");
    
    const [clublist, setList] = useState("");
    
    const [value, setValue] = React.useState(new Date());
    const [selectedDate, handleDateChange] = useState(new Date());
    const handleChange = (newValue) => {
      setValue(newValue);
    };


    const handleChangeDebut = (newValue) => {
        var d = new Date(newValue);
        console.log(d.getFullYear());
        setDateDebut(d.getFullYear());
        setDateDebutTmp(newValue);
      };
  
    

    useEffect(() => {

        const fetchData = async () => {
            try {

                let RuleReport = await getUserRule("read_reports",sessionStorage.getItem('clubId'),sessionStorage.getItem('secteur'));
                setAutorize(RuleReport);

            } catch (error) {
                console.error('Une erreur s\'est produite lors de la récupération des données', error);
              }
        };
        fetchData(); // Appel de la fonction asynchrone
        
        if(autorize)
        {
            if(!dateDebutTmp) {
                setDateDebutTmp(myear);
                setDateDebut(myear);       
            }

            if(!reportname)        
            {
                setreportname(myreport);
            }
        }
       // setreportname('getreportEffectif');

      // console.log("LE CLUB est le : " + this.props.clubid)
      //setFormValue(clubid,this.props.clubid);
       //this.setState({clubid: this.props.clubid}); 
       //setDateDebutTmp(Date().getFullYear);
     //  handleDateChange(Date().getFullYear);
      //  setDateDebut(dateDebutTmp);


       }, [dateDebutTmp,reportname]);
       
/*
   function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return year;
    }*/
    const handleChangeReports = (event) => {
        setreportname(event.target.value);
      };


      function mainHtml()
      {
  
          if(autorize)
          {
              return (<div>
                          <div style={{  width: '90%', margin: '3%' }}>
                                <Typography variant="h4" gutterBottom>
                                    Rapport des effectifs
                                </Typography>

                                <Grid container direction="row" >
                                    <Grid item xs={1} container direction="row" > 
                                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'> 

                                        <DatePicker id="MyYear"
                                            views={['year']}
                                            label="Année"
                                            inputFormat="YYYY"
                                            value={dateDebutTmp}
                                            onChange={handleChangeDebut}
                                            renderInput={(params) => <TextField {...params} />}
                                            />

                                        </LocalizationProvider>  
                                    
                                        </Grid>
                                
                                        <Grid item xs={3} container direction="row" > 
                                                                
                                    </Grid>                                            
                                </Grid>

                                                    
                                <RepportBySector key="sdsadsad" annee={dateDebut} reportname="getReportCompletAnneeEffectif" />
                                

                            </div>
                      </div>);
          }
          else
              return "";
  
      }
    
        

        return (
           <div>
                <Autorize axiosError={errorAxios}/>

                {mainHtml()}
                   
            </div>
            
        );
   
};

export default Reports;